import { useCallback, useState } from 'react';
import { Roles } from '../../AddProject/types/types';

export type OpenedInviteCard = null | Roles;

export const useProjectTeamInvite = () => {
    const [openedInviteCard, setOpenedInviteCard] = useState<OpenedInviteCard>(null);

    const onOpenedInviteCardChange = useCallback((value: OpenedInviteCard) => {
        setOpenedInviteCard(value);
    }, []);

    const [closingCard, setClosingCard] = useState<string | null>(null);
    const onSetClosingCard = (value: string | null) => {
        setClosingCard(value);
    };

    return { openedInviteCard, onOpenedInviteCardChange, closingCard, onSetClosingCard };
};
